import { useEffect, useState } from "react";

export const DeviceType = {
  MOBILE: "mobile",
  TABLET: "tablet",
  DESKTOP: "desktop",
};

function getDeviceType() {
  if (!window) {
    return null
  }
  const width = window.innerWidth;
  if (width < 768) {
    return DeviceType.MOBILE;
  } else if (width < 1024) {
    return DeviceType.TABLET;
  }
  return DeviceType.DESKTOP;
}

export function useDeviceType() {
  const [deviceType, setDeviceType] = useState(getDeviceType());
  useEffect(() => {
    function checkDeviceType() {
      setDeviceType(getDeviceType());
    }
    checkDeviceType();
    window.addEventListener("resize", checkDeviceType);
    return () => {
      window.removeEventListener("resize", checkDeviceType);
    };
  }, []);

  return deviceType;
}
